import { Controller, FieldValues, useController, useWatch } from "react-hook-form"
import useAsyncService from "../../../hooks/useAsyncService"
import { loadCollections } from "../../../services/APIServices"
import { useEffect } from "react"
import { LoadIndicator, TagBox } from "devextreme-react"
import React from "react"
import ICSErrorCard from "../../../components/ICSErrorCard/ICSErrorCard"


export const Collection = ({
    name,
    control,
}) => {
    const { serviceValue, serviceLoading, serviceError, setServiceArgs } = useAsyncService<string, string[]>({
        serviceCall: loadCollections,
        delay: 300,
        initialArgs: null
    })

    const {
        field: { value, onChange, ref },
        fieldState: { invalid, error }
    } = useController<FieldValues>({
        name,
        control
    })
    

    const vpick = useWatch({name: "vehiclePicker", control})

    useEffect(() => {
        const fleetParams = vpick.fleets.map(fleet => `f=${encodeURIComponent(fleet)}`).join('&')
        const vehicleParams = vpick.vehicles.map(vehicle => `v=${encodeURIComponent(vehicle)}`).join('&')
        const query = [fleetParams, vehicleParams].filter(param => param).join('&')
        
        setServiceArgs(query ? query : null) // if nothing is selected, clear

    }, [vpick])

    const toggleItem = (e: string[] ) => {
        onChange(e)
    }


    const Output = () => {
        if (serviceError) {
            return (
            <ICSErrorCard
              code={'error'}
              message={serviceError}
              fields={[]}
            />)
        }else if(serviceLoading == true) {  
            return <LoadIndicator />  
        }
        else {
            return (
                <TagBox
                    id={`${name}Start`}
                    items={serviceValue || []}
                    acceptCustomValue={true}
                    onValueChange={toggleItem}
                    placeholder={'Input text and hit enter to create a tag'}
                    ref={ref}
                    value={value}
                    searchEnabled={true}
                />
            )
        }
    }
    
    return(
        <Output />  
    )
}